import * as React from 'react';
import { ChoiceGroup, IChoiceGroupOption, MessageBar, MessageBarType, Icon, TooltipHost, TooltipDelay } from 'office-ui-fabric-react';
import { EstimatedChargeCalculationMode } from '../../../entities/common';

type Props = {
    value?: EstimatedChargeCalculationMode;
    readonly?: boolean;
    onChange: (value: EstimatedChargeCalculationMode) => void;
}

export const ResourcePlanSettingsSection: React.FC<Props> = (props) => {
    const options: IChoiceGroupOption[] = [
        {
            key: EstimatedChargeCalculationMode.UseChargeRate.toString(),
            text: 'Use Charge Rate in the resource plan'
        },
        {
            key: EstimatedChargeCalculationMode.UseCostRateTables.toString(),
            text: 'Use Cost Rate Tables in the resource plan'
        }
    ];

    return (
        <div className="settings-section">
            <div className="section-description">
                Select Estimated Charge calculation method
            </div>
            <MessageBar messageBarType={MessageBarType.warning} isMultiline>
                Estimated Charge in the resource plan will be automatically re-calculated
            </MessageBar>
            <div className='choice-header'>
                Estimated Charge Calculation
                <TooltipHost
                    hostClassName='choice-header-host'
                    tooltipProps={{
                        onRenderContent: () => <>Define how Estimated Charge should be calculated in the resource plan - using a single Charge Rate or Cost Rate Tables.</>
                    }}
                    delay={TooltipDelay.zero} >
                    <Icon iconName="Info" onClick={(e) => e.stopPropagation()} className="info-icon" />
                </TooltipHost>
            </div>
            <ChoiceGroup
                defaultSelectedKey={props.value?.toString()}
                options={options}
                disabled={props.readonly}
                onChange={(_, option) => {
                    if (option) {
                        props.onChange(parseInt(option.key) as EstimatedChargeCalculationMode);
                    }
                }}
            />
        </div>
    );
};
